module.exports = __webpack_public_path__ + "static/media/19ESCAP19.63151a53.jpg";